import { PreSignedUrlResponse } from '../dto/ResDtoRepository';
import { PreSignedUrlReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendAWSApiRequest } from './apiConfig';


export const getPreSignedUrl = async (aui: string, data: PreSignedUrlReq): Promise<PreSignedUrlResponse> => {
  return sendApiRequest<PreSignedUrlResponse>('post', `/pre-signed-url?aui=${aui}`, data);
};

export const uploadFileWithPreSignedUrl = async (url: string, file: File): Promise<void> => {
  return sendAWSApiRequest<void>('put', `${url}`, file);
};
